import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { api } from "../api/axios"; 
import { toast } from "react-toastify";
import { useI18n } from "../../i18n/I18nContext";

export default function Register() {
  const { openCart } = useCart();
  const navigate = useNavigate();
  const { t } = useI18n();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const localCart = JSON.parse(localStorage.getItem("cart") || "[]");

      const cart_items = Array.isArray(localCart)
        ? localCart
            .map((i) => ({
              product_variant_id: Number(i.variant_id ?? i.id),
              quantity: Number(i.quantity),
            }))
            .filter(
              (x) =>
                Number.isInteger(x.product_variant_id) &&
                x.product_variant_id > 0 &&
                Number.isInteger(x.quantity) &&
                x.quantity > 0
            )
        : [];

      const res = await api.post("/api/register", { 
        name,
        email,
        password,
        password_confirmation: passwordConfirmation,
        cart_items,
      });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      localStorage.removeItem("cart");

      const returnTo = localStorage.getItem("returnTo") || "/products";
      localStorage.removeItem("returnTo");

      toast.success(t("Conta criada com sucesso!"));
      navigate(returnTo);
      if (returnTo !== "/products") openCart();
    } catch (err) {
      const data = err?.response?.data;

      if (data?.errors) {
      
        const firstError = Object.values(data.errors)[0]?.[0];
        toast.error(firstError || t("Erro de validação."));
      } else {
        toast.error(data?.message || t("Erro no registo."));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white rounded-lg shadow p-8">
        <h1 className="text-2xl font-bold mb-6 text-center">{t("Registar")}</h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">
              {t("Nome")}
            </label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoComplete="name"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              {t("Email")}
            </label>
            <input
              type="email"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              {t("Password")}
            </label>
            <input
              type="password"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              {t("Confirmar password")}
            </label>
            <input
              type="password"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              autoComplete="new-password"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gray-900 text-white rounded py-2 font-semibold disabled:opacity-60"
          >
            {loading ? t("A criar conta...") : t("Criar conta")}
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-600">
          {t("Já tens conta?")}{" "}
          <button
            className="text-indigo-600 font-semibold hover:underline"
            onClick={() => navigate("/login")}
          >
            {t("Entrar")}
          </button>
        </div>
      </div>
    </div>
  );
}